<p-progress-spinner  strokeWidth="4" fill="transparent"  animationDuration=".5s" [style]="{ width: '20px', height: '20px' }" />